<form>
	<!-- Modal Header -->
	<div class="modal-header">
		<h4 class="modal-title">Asset Sheet Request Log</h4>
		<button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()"></button>
	</div>

	<div class="modal-body">
		<div class="row">
			<div class="col-4">
				<mat-form-field class="full-width-formField p-0">
					<input matInput readonly [matDatepicker]="startDatePicker" name="startDate" [(ngModel)]="requestedAfter" placeholder="Start" required />
					<mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
					<mat-datepicker #startDatePicker name="startDatePicker"></mat-datepicker>
				</mat-form-field>
			</div>
			<div class="col-4">
				<mat-form-field class="full-width-formField p-0">
					<input matInput readonly [matDatepicker]="endDatePicker" name="endDate" [(ngModel)]="requestedBefore" required />
					<mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
					<mat-datepicker #endDatePicker name="endDatePicker"></mat-datepicker>
				</mat-form-field>
			</div>

			@if (sharedService.isMonitoringUser()) {
				<div class="col-3">
					<div class="p-3 d-flex justify-content-center align-items-center">
						<select class="browser-default form-select" name="selectedCompany" [(ngModel)]="companyId">
							@for (company of companyList; track company) {
								<option [value]="company.ID">
									{{ company.CompanyCode }}
								</option>
							}
						</select>
					</div>
				</div>
			}

			<div class="col-4">
				<button class="btn btn-info" (click)="submit()">Go</button>
			</div>
		</div>

		@if (assetSheetRequestList.length > 0) {
			<table class="table table-bordered" style="width: 100%; table-layout: fixed; word-wrap: break-word">
				<tbody>
					<tr>
						<th>UUID</th>
						<th>Type</th>
						<th>Form J Company</th>
						<th>Total Amount</th>
						<th>Branch Name</th>
						<th>Account Details</th>
						<th>CustomerName</th>
						<th>Line Amount</th>
						<th>Remark</th>
						<th>Timestamp</th>
						<th>RequestedBy</th>
					</tr>
					@for (sd of assetSheetRequestList; track sd) {
						<tr>
							<td>{{ sd.Uuid }}</td>
							<td>{{ sd.Type }}</td>
							<td>{{ sd.FormJCompany }}</td>
							<td>{{ sd.MbbMaster }}|{{ sd.OtherBankMaster }}</td>
							<td>{{ sd.BranchName }}</td>
							<td>{{ sd.AccountDetails }}</td>
							<td>{{ sd.CustomerName }}</td>
							<td>{{ sd.LineAmount }}</td>
							<td>{{ sd.Remark }}</td>
							<td>{{ sd.Timestamp }}</td>
							<td>{{ sd.RequestedBy }}</td>
						</tr>
					}
				</tbody>
			</table>
		} @else {
			<p>There's no previous log for the sheet details</p>
		}
	</div>
	<!-- <div class="modal-footer">
        <button class="btn btn-outline-success" type="button" (click)="submit()" [disabled]="disabledSubmit">
            Submit
        </button>
        <button class="btn btn-outline-danger" type="button" (click)="reset()">Cancel</button>
    </div> -->
</form>
